import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API } from "@/App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        navigate("/admin", { replace: true, state: { user: r.data } });
      } catch {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0D1729] text-white flex items-center justify-center">
      <div className="mono-label">AUTHORISING SESSION…</div>
    </div>
  );
}
